import { Action } from 'redux';
import { CheckoutActionTypes } from '../../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface InitAddressSearchEditorAction extends Action<CheckoutActionTypes.INIT_ADDRESS_SEARCH_EDITOR> {
    addressSearchEditorId: string;
}

export const initAddressSearchEditor: (addressSearchEditorId: string) => InitAddressSearchEditorAction = (addressSearchEditorId: string) => ({
    type: CheckoutActionTypes.INIT_ADDRESS_SEARCH_EDITOR,
    addressSearchEditorId
});
initAddressSearchEditor[ACTION_CREATOR_NAME] = 'initAddressSearchEditor';

export type InitAddressSearchEditorFunc = (...args: Parameters<typeof initAddressSearchEditor>) => void;
